import { NewChanges } from './types';


// export function HandleChanges<Type>(
//     allData: boolean,
//     changes: Changes<Type>,
//     masterData: Type[],
//     comp: (a: Type, b: Type) => boolean,
//     applyToAllRows: (a: Type) => void): boolean {
//     let hasAnyChange = false;
//     if (allData) {
//         hasAnyChange = masterData.length > 0;
//         masterData.length = 0;
//     }

//     if (HandleDeletes(changes.delete, masterData, comp, applyToAllRows)) {
//         hasAnyChange = true;
//     }

//     if (HandleUpdates(changes.update, masterData, comp, applyToAllRows)) {
//         hasAnyChange = true;
//     }

//     if (HandleAdds(changes.add, masterData, applyToAllRows)) {
//         hasAnyChange = true;
//     }

//     return hasAnyChange;
// }




export function HandleChangesNew<Type>(
    allData: boolean,
    changes: NewChanges<Type>,
    masterData: Type[],
    applyToAllRows: (a: Type) => void,
    idFields: string[]): boolean {
    let hasAnyChange = false;
    if (allData) {
        hasAnyChange = masterData.length > 0;
        masterData.length = 0;
    }

    if (changes.delete != null) {
        for (let i = 0; i < changes.delete.length; ++i) {
            let tmpObj = {};
            let idx = 0;
            for (const field of idFields) {
                tmpObj[field] = changes.delete[i][idx++];
            }
            const index = IndexOf(masterData, tmpObj, idFields);

            if (index > -1) {
                masterData.splice(index, 1);
                hasAnyChange = true;
            }
        }
    }

    if (changes.upsert != null) {
        for (let i = 0; i < changes.upsert.length; ++i) {
            const change = changes.upsert[i];
            applyToAllRows(change);

            const index = IndexOf(masterData, change, idFields);
            if (index > -1) {
                masterData[index] = change;
            } else {
                masterData.push(change);
            }
            hasAnyChange = true;
        }
    }

    return hasAnyChange;
}

function CreateId(value: any, idFields: string[]): string {
    let out = '';
    for (const field of idFields) {
        out = out + '-' + value[field];
    }
    return out;
}

function IndexOf<Type>(input: Type[], value: Type, idFields: string[]): number {
    const valueId = CreateId(value, idFields);
    for (let i = 0; i < input.length; ++i) {
        const id = CreateId(input[i], idFields);
        if (id == valueId) {
            return i;
        }
    }

    return -1;
}
